import { createAgnosticStrongAuthRepository } from 'auth/infra/createAgnosticStrongAuthRepository'

import { AttachmentRepository } from './AttachmentRepository'
import { SHIPPER_GUIDE_API_URL } from './environment'
import { createTokenInterceptor, HttpClient } from './http/HttpClient'

export function createAttachmentRepository() {
  const userRepository = createAgnosticStrongAuthRepository()

  const httpClient = new HttpClient(SHIPPER_GUIDE_API_URL, {
    requestInterceptor: createTokenInterceptor({ userRepository, authorizationType: 'JWT' }),
  })

  const attachmentRepository = new AttachmentRepository({ httpClient })

  return attachmentRepository
}
